var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M 6.25 43.75 L 93.75 43.75 L 93.75 56.25 L 6.25 56.25 Z M 6.25 43.75"}})])}
var staticRenderFns = []

export { render, staticRenderFns }